<template>
  <v-container
    fluid
    class="mt-6 mx-7"
  >
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
    >
      <base-material-card
        color="primary"
        icon="mdi-lightning-bolt"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <div class="display-1 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-form class="pt-8">
          <v-row no-gutters>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  v-model="nome"
                  label="Nome"
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-1"
          >
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  v-model="tipo"
                  :items="[{key: 'POWER_UP', value: 'Menu :: Power Up'}, {key: 'DADOS', value: 'Menu :: Dados'}]"
                  item-value="key"
                  item-text="value"
                  label="Tipo"
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-1"
          >
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  v-model="categoria_id"
                  :items="categorias"
                  item-value="id"
                  item-text="nome"
                  label="Categoria"
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-1"
          >
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  v-model="descricao"
                  label="Descrição"
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-1"
          >
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  v-model="link_base_rota_principal"
                  label="Link Base Rota Principal Completa"
                  outlined
                  placeholder="Ex.: ais"
                  hint="Esse valor refere-se ao path base da url"
                  persistent-hint
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-1"
          >
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  v-model="link_rota_principal_completo"
                  label="Link Rota Principal Completa"
                  outlined
                  placeholder="Ex.: ais/mutacao/"
                  hint="Esse valor refere-se ao path completo da url"
                  persistent-hint
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-1"
          >
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  v-model="icone"
                  label="Icone"
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-1"
          >
            <v-col class="mt-n5">
              <v-checkbox
                v-model="ferramenta_exclusiva_hexa_v1"
                label="Ferramenta está no Hexa v1?"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col />
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="green"
                min-width="100"
                style="float: right"
                class="mr-0 mt-2"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
import FerramentasService from '@/services/FerramentasService';
import CategoriasService from '@/services/CategoriasService';

export default {
  data: () => ({
    categorias: [],
    nome: '',
    tipo: '',
    categoria_id: '',
    descricao: '',
    link_base_rota_principal: '',
    link_rota_principal_completo: '',
    icone: '',
    ferramenta_exclusiva_hexa_v1: false,
    loading:false
  }),

  computed: {
    title() {
      return this.$route.params.id ? 'Editando Power Up' : 'Adicionar Novo Power Up';
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.getById(this.$route.params.id);
    } else {
      this.getCategorias();
    }
  },

  methods: {
    getById(id) {
      FerramentasService.getById(id).then(response => {
        const categorias = response.data.categorias;
        const { nome, tipo, categoria_id, descricao, link_base_rota_principal, link_rota_principal_completo, icone, ferramenta_exclusiva_hexa_v1 } = response.data.ferramenta;
        
        this.nome = nome;
        this.tipo = tipo;
        this.categoria_id = categoria_id;
        this.descricao = descricao;
        this.link_base_rota_principal = link_base_rota_principal;
        this.link_rota_principal_completo = link_rota_principal_completo;
        this.icone = icone;
        this.ferramenta_exclusiva_hexa_v1 = ferramenta_exclusiva_hexa_v1;
        this.categorias = categorias;
      })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar power ups.', '', {position:'topRight'});
        });
    },

    getCategorias() {
      this.items = [];
      
      CategoriasService.getAll()
        .then(response => this.categorias = response.data.data)
        .catch (error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar as categorias.', '', {position:'topRight'});
        });
    },

    salvar() {
      this.loading = true;

      const data = {
        id: this.$route.params.id ? this.$route.params.id : null,
        nome: this.nome,
        tipo: this.tipo,
        categoria_id: this.categoria_id,
        descricao: this.descricao,
        link_base_rota_principal: this.link_base_rota_principal,
        link_rota_principal_completo: this.link_rota_principal_completo,
        icone: this.icone,
        ferramenta_exclusiva_hexa_v1: this.ferramenta_exclusiva_hexa_v1
      };
      
      FerramentasService.salvar(data).then(() => {
        this.$toast.success('Power up salvo com sucesso.', '', {position:'topRight'});
        this.$router.push({ name: 'Power Ups Config' });
      })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao salvar power up.', '', {position:'topRight'});
        })
        .finally(() => this.loading = false);
    }
  }
};
</script>